import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, control, radius, shadow } = theme.tokens;
  const reset = {
    appearance: "none",
    border: 0,
    margin: 0,
    padding: 0,
    font: "inherit",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  const springy = "cubic-bezier(.34,1.56,.64,1)";
  const noMotion = "@media (prefers-reduced-motion: reduce)";

  return {
    // round "+" grows into the "− qty +" pill on first add
    "@keyframes pillIn": {
      "0%": { transform: "scale(.6)", opacity: 0.4 },
      "60%": { transform: "scale(1.08)", opacity: 1 },
      "100%": { transform: "scale(1)" }
    },
    // quantity number bumps up on every change
    "@keyframes qtyPop": {
      "0%": { transform: "translateY(40%) scale(.6)", opacity: 0 },
      "100%": { transform: "translateY(0) scale(1)", opacity: 1 }
    },
    addRound: {
      ...reset,
      width: control.sm,
      height: control.sm,
      borderRadius: radius.pill,
      backgroundColor: color.bg,
      color: color.ink,
      transition: `background-color .15s, color .15s, transform .2s ${springy}`,
      "&:hover": {
        backgroundColor: color.ink,
        color: color.bg,
        transform: "scale(1.08)"
      },
      "&:active": { transform: "scale(.85)", transition: "transform .06s" },
      [noMotion]: {
        transition: "none",
        "&:hover, &:active": { transform: "none" }
      }
    },
    pill: {
      height: control.sm,
      borderRadius: radius.pill,
      backgroundColor: color.ink,
      color: color.bg,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between",
      transformOrigin: "right center"
    },
    // set by GStepper once the user has changed qty in this session
    animate: {
      "&$pill": { animation: `$pillIn .32s ${springy}` },
      "& $qty": { animation: `$qtyPop .22s ${springy}` },
      [noMotion]: { "&$pill, & $qty": { animation: "none" } }
    },
    tile: {
      boxShadow: shadow.float,
      "&$pill": { boxShadow: shadow.overlay }
    },
    inline: {
      "&$addRound": {
        backgroundColor: color.field,
        "&:hover": { backgroundColor: color.ink, color: color.bg }
      }
    },
    lg: {
      "&$pill": {
        width: "100%",
        height: control.lg,
        "& $stepBtn": { width: control.lg, height: control.lg },
        "& $qty": { fontSize: theme.tokens.fontSize.title }
      }
    },
    stepBtn: {
      ...reset,
      width: control.sm,
      height: control.sm,
      borderRadius: radius.pill,
      background: "none",
      color: "inherit",
      transition: `background-color .15s, transform .2s ${springy}`,
      "&:hover": { backgroundColor: color.inkHover },
      "&:active": { transform: "scale(.85)", transition: "transform .06s" },
      [noMotion]: { transition: "none", "&:active": { transform: "none" } }
    },
    disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      "&:hover": { background: "none" }
    },
    qty: {
      minWidth: 16,
      textAlign: "center",
      fontWeight: 800,
      fontSize: theme.tokens.fontSize.body,
      display: "inline-block"
    }
  };
});

export default withCustomStyles;
